module.exports = __webpack_public_path__ + "img/sanatorio-guemes.3e0f5c40.png";